import React from 'react';
import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { trackPageView, getCampaignSource, trackEvent } from './utils/analytics';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { cssBaselineOverrides } from './theme/overrides';
import { Container, CssBaseline } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import AIReadinessAssessment from './pages/AIReadinessAssessment';
import AIPolicyDevelopment from './pages/AIPolicyDevelopment';
import EndToEndAIConsulting from './pages/EndToEndAIConsulting';
import RapidAIAutomationSprint from './pages/RapidAIAutomationSprint';
import FreeAIAssessment from './pages/FreeAIAssessment';
import FreeAIThankYou from './pages/FreeAIThankYou';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import FAQ from './pages/FAQ';
import NotFound from './pages/NotFound';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#182D46', contrastText: '#ffffff' }, // Navy
    secondary: { main: '#FF8210', contrastText: '#182D46' }, // Orange
    background: {
      default: '#f5f7fa',
      paper: '#ffffff',
    },
    text: { primary: '#182D46', secondary: '#617E89' },
  },
  typography: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    button: {
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: cssBaselineOverrides,
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#182D46',
        },
      },
    },
  },
});


function Layout() {
  return (
    <>
      <Header />
      <Container sx={{ my: 4 }}>
        <Outlet />
      </Container>
      <Footer />
    </>
  );
}

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  useEffect(() => {
    const src = getCampaignSource();
    if (src) {
      trackEvent('campaign_click', { source: src });
    }
  }, []);
  return null;
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Layout />}> 
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="services/ai-readiness-assessment" element={<AIReadinessAssessment />} />
          <Route path="services/ai-policy-development" element={<AIPolicyDevelopment />} />
          <Route path="services/end-to-end-ai-consulting" element={<EndToEndAIConsulting />} />
          <Route path="services/rapid-ai-automation-sprint" element={<RapidAIAutomationSprint />} />
          <Route path="services/free-ai-assessment" element={<FreeAIAssessment />} />
          <Route path="services/free-ai-assessment/thank-you" element={<FreeAIThankYou />} />
          <Route path="resources/*" element={<Resources />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy" element={<Privacy />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
